import React from 'react'
import classnames from 'classnames'
import PlayerDetails from '../PlayerDetails'
import { AnchorLink } from '../../common'
import { PieChart, CompareLineGraph } from '../../common/Graphics'
import { PartnershipsList } from './Partnerships'

export const PitchMap = ({
  map = {}
}) => {

  const renderGrid = (grid = [], totalBalls) => {
    // Using colors generated by a color blender
    // TODO: get updated color classnames and use them
    const colors = [ '#F2C50C', '#F2B320', '#F2A127', '#F08F2C', '#EF7D30' ]

    return grid.map((rows = [], i) => {
      return (
        <tr key={i}>
          {
            rows.map((column, j) => {
              const wickets = column[1]
              const balls = column[2]
              const percent = (balls/totalBalls) * 100
              let bgColor = '#fff'

              if(percent > 81) {
                bgColor = colors[4]
              }else if(percent >= 61 && percent < 81) {
                bgColor = colors[3]
              }else if(percent >= 41 && percent < 61) {
                bgColor = colors[2]
              }else if(percent >= 21 && percent < 41) {
                bgColor = colors[1]
              }else if(percent >= 1 && percent < 21) {
                bgColor = colors[0]
              }

              return <td key={j} style={{ backgroundColor: bgColor }}>{wickets > 0 ? wickets + 'W' : ''}</td>
            })
          }
        </tr>
      )
    })
  }

  return (
    <div className="chart-table-container">
      {
        map.rhb.map &&
        <table className="chart-table">
          <caption>RHB
            <div><span>OFF</span><span className="icon-wicket"></span><span>LEG</span></div>
          </caption>
          <tbody>
          {
            renderGrid(map.rhb.map, map.rhb.totalBalls)
          }
          </tbody>
        </table>
      }
      {
        (map.rhb.map || map.lhb.map) &&
        <ul className="chart-table-headers">
          <li><span className="label short">FT</span><span className="label full">FULL TOSS</span></li>
          <li><span className="label short">Y</span><span className="label full">YORKER</span></li>
          <li><span className="label short">F</span><span className="label full">FULL LENGTH</span></li>
          <li><span className="label short">G</span><span className="label full">GOOD LENGTH</span></li>
          <li><span className="label short">SG</span><span className="label full">SHORT OF GOOD LENGTH</span></li>
          <li><span className="label short">S</span><span className="label full">SHORT LENGTH</span></li>
        </ul>
      }
      {
        map.lhb.map &&
        <table className="chart-table" cellPadding="0" cellSpacing="0">
          <caption>LHB
            <div><span>LEG</span><span className="icon-wicket"></span><span>OFF</span></div>
          </caption>
          <tbody>
          {
            renderGrid(map.lhb.map, map.lhb.totalBalls)
          }
          </tbody>
        </table>
      }
    </div>
  )
}

export const CurrentPartnerships = (props = {}) => {

  const { values = [], title = 'PARTNERSHIPS' } = props

  const partnerships = (
    <div className="stat-container partnerships">
      <h3>{title}</h3>
      <PartnershipsList values={values} title={title} />
    </div>
  )

  return values.length ? partnerships : <div className="stat-container partnerships" />
}

const Batsman = ({
  href = '#',
  img = '',
  name = '',
  team = '',
  runs = '',
  control = '',
  productive = {
    shotType : '',
    runs: '',
    details: ''
  },
  pie = [],
  top
}) => {

  const dataVisStyle = {}

  if(!pie.length) {
    dataVisStyle.minHeight = '50px'
  }

  return (
    <div className="player">
      <PlayerDetails name={name} team={team} img={img} href={href} />
      <div className="runs" dangerouslySetInnerHTML={{ __html : runs }}></div>
      <div className="data-vis" style={dataVisStyle}>
        <div className="data-vis-col left">

          {
            control && <CompareLineGraph value={control} text="Control %" /> || null
          }
          <div className="data-text">
            {
              productive.shotType &&
              <ul>
                { productive.runs && <li className="header">Productive Shot</li> }
                { productive.runs && <li style={{ textTransform: 'capitalize' }} className="shot-type">{productive.shotType}</li> }
                <li className="data-runs">{productive.runs} runs</li>
                <li dangerouslySetInnerHTML={{ __html: productive.details }}></li>
              </ul>
            }
          </div>
        </div>
        {
          pie.length &&
          <PieChart className="right" topSlice={top} values={pie} /> || null
        }
      </div>
    </div>
  )
}

const Bowler = ({
  pitchMap = [],
  name = '',
  team = '',
  img = '',
  href = '',
  stats = []
}) => {

  return (
    <div className="player">
      <PlayerDetails name={name} team={team} img={img} href={href} />
      <dl className="stat-overview">
        {
          stats.map((stat, i) => {
            return <dd key={i}><span className="label">{stat.text || stat.abbreviation}</span><span className="value">{stat.value}</span></dd>
          })
        }
      </dl>
      <PitchMap map={pitchMap} />
    </div>

  )
}

export const BestPerformers = ({
  type = '',
  players = [],
  title = ''
}) => {
  const content = (
    <article className="sub-module stats">
        <header className="bordered">
           <h1>{title}</h1>
        </header>
        <div className="content">
          <div className={classnames('stat-container', type)}>
            {
              players.map((player, i) => {
                if(type == 'batsman') {
                  return <Batsman key={i} {...player} />
                }else if(type == 'bowler') {
                  return <Bowler key={i} {...player} />
                }
              })
            }
          </div>
      </div>
    </article>
  )

  return players.length ? content : <article className="sub-module stats" style={{ display: 'none' }} />
}

export const Statistics = ({
  partnerships = [],
  link = '#',
  batsmen = [],
  bowlers = [],
  hideShowClass,
  showFooter = false,
  gameState = '',
  titles = { batsmen: 'Current Batsmen', bowlers: 'Current bowlers' },
  trackingName = ''
}) => {
  const content = (
    <div className={hideShowClass ? 'hide-show' : ''}>
      <article className="sub-module stats">

          <header className="bordered">
             <h1>Statistics</h1>
          </header>
          <div className="content">
           {
              batsmen.length &&
              <div className="stat-container batsmen">
                <h3>{titles.batsmen}</h3>
                {
                  batsmen.map((batsman, i) => {
                    return <Batsman key={i} {...batsman} />
                  })
                }
              </div> || null
            }
            {
              bowlers.length && <div className="stat-container bowler">
                { bowlers.length && <h3>{titles.bowlers}</h3> }
                {
                  bowlers.map((bowler, i) => {
                    return <Bowler key={i} {...bowler} />
                  })
                }
              </div> || null
            }
            {
              gameState == 'live' && <CurrentPartnerships values={partnerships} />
            }
        </div>
        {
          showFooter &&
            <footer>
              <AnchorLink to={link} name={trackingName} text="More Statistics"/>
            </footer>
        }
      </article>
    </div>
  )

  if(batsmen.length || bowlers.length || (gameState == 'live' && partnerships.length)) {
    return content
  }else{
    return <article className="sub-module stats" style={{ display: 'none' }} />
  }
}



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/Statistics.jsx